import * as React from "react";
import {cn} from "./utils";
import "./ui.css";
import "./Input.module.css";

const Input = React.forwardRef(({className, type, ...props}, ref) => {
    return <input ref={ref} type={type} data-slot="input" className={cn("ui-input", className)} {...props} />;
});

Input.displayName = "Input";

export {Input};
